import { useEffect, useState } from "react";

// «Pantalla aparte abierta» entre pestañas/ventanas del MISMO navegador (Mesa del jefe, orden del Founder 2026-10-26).
// Mecanismo: latido en localStorage con caducidad. La pantalla aparte escribe la hora cada pocos segundos; si el último latido
// es más viejo que TTL (ventana cerrada a la fuerza, navegador caído) se considera cerrada. Sin latido => el Monitoreo se ve como siempre.
// La orden de cerrar viaja igual (otra clave): la ventana aparte la escucha con el evento `storage` y se cierra sola.
export const LATIDO_KEY = "cc.pantalla.latido";
export const CERRAR_KEY = "cc.pantalla.cerrar";
export const LATIDO_MS = 2000;
export const TTL_MS = 6000;

export function pantallaAbierta(now = Date.now()) {
  try {
    const t = Number(localStorage.getItem(LATIDO_KEY));
    return Number.isFinite(t) && t > 0 && now - t < TTL_MS && now - t > -TTL_MS;
  } catch (e) { return false; }
}

/** Lo usa la ventana de la pantalla aparte: late mientras exista y avisa al irse. `onCerrar` = el jefe pidió cerrarla. */
export function usePantallaAparteLatido(onCerrar) {
  useEffect(() => {
    const beat = () => { try { localStorage.setItem(LATIDO_KEY, String(Date.now())); } catch (e) { /* sin almacenamiento: el Monitoreo queda como siempre */ } };
    const gone = () => { try { localStorage.removeItem(LATIDO_KEY); } catch (e) { /* ignorar */ } };
    const onStorage = (e) => { if (e.key === CERRAR_KEY && e.newValue) onCerrar?.(); };
    beat();
    const id = setInterval(beat, LATIDO_MS);
    window.addEventListener("pagehide", gone);
    window.addEventListener("storage", onStorage);
    return () => { clearInterval(id); window.removeEventListener("pagehide", gone); window.removeEventListener("storage", onStorage); gone(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

/** Lo usa la PC del jefe: true mientras haya una pantalla aparte latiendo (se revisa cada segundo y al instante con `storage`). */
export function usePantallaAparteAbierta() {
  const [open, setOpen] = useState(() => pantallaAbierta());
  useEffect(() => {
    const check = () => setOpen(pantallaAbierta());
    const id = setInterval(check, 1000);
    const onStorage = (e) => { if (e.key === LATIDO_KEY || e.key === null) check(); };
    window.addEventListener("storage", onStorage);
    check();
    return () => { clearInterval(id); window.removeEventListener("storage", onStorage); };
  }, []);
  return open;
}

/** Pide a la pantalla aparte que se cierre (solo cierra la ventana; no toca llamadas ni datos). */
export function pedirCerrarPantallaAparte() {
  try { localStorage.setItem(CERRAR_KEY, String(Date.now())); localStorage.removeItem(CERRAR_KEY); } catch (e) { /* ignorar */ }
}
